import { onlyNumbers, hasAnyLetter } from '@/utils/regex-utils';

export default {
  statusOptions(state) {
    return state.statusOptions;
  },
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  localEntrega(state) {
    return state.localEntrega;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  grupo(state) {
    return state.grupo;
  },
  solicitante(state) {
    return state.solicitante;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  listOptions(state) {
    return state.listOptions;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.localEntrega,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.dataFinal,
      state.dataInicial,
      state.grupo && state.grupo.length,
      state.solicitante && state.solicitante.length,
      state.fornecedor && state.fornecedor.length,
    ].some(v => !!v);
  },
  stringFilterSaldo(state) {
    if (state.selectedStatus && state.selectedStatus.valueSaldo) {
      return state.selectedStatus.valueSaldo();
    }
    return '';
  },
  stringFilter(state) {
    const filters = ['(situacaoCompra != \'CANCELADA\' and situacaoCompra != \'RECUSADA\' and situacao != \'CANCELADO\')'];
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      const idFilter = !hasAnyLetter(state.searchText) ? ` or compra.id = ${onlyNumbers(state.searchText)}` : '';
      filters.push(`(produto.descricao like '%${searchText}%' or produto.codigo like '%${searchText}%' or compra.codigoInterno like '%${searchText}%')${idFilter}`);
    }
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(state.selectedStatus.value());
    }
    if (state.dataInicial) {
      filters.push(`(dataPrevisaoEntrega >= ${state.dataInicial})`);
    }
    if (state.dataFinal) {
      filters.push(`(dataPrevisaoEntrega <= ${state.dataFinal})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.localEntrega && state.localEntrega.id) {
      filters.push(`(localEntrega.id = ${state.localEntrega.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(grupo => `(produto.categoria.id = ${grupo.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    if (state.solicitante && state.solicitante.length) {
      const solicitanteFilter = state.solicitante.map(solicitante => `(solicitante = ${solicitante.id})`);
      filters.push(`(${solicitanteFilter.join(' or ')})`);
    }
    if (state.fornecedor && state.fornecedor.length) {
      const fornecedorFilter = state.fornecedor.map(fornecedor => `(fornecedor.id = ${fornecedor.id})`);
      filters.push(`(${fornecedorFilter.join(' or ')})`);
    }
    return filters.join(' and ');
  },
};
